export enum TypeResource {
    PHOTO = 'PHOTO',
    PI_COM = 'PI_COM',
    VIDEO = 'VIDEO',
}

export enum ExportOptionKey {
    CATALOGUE = 'CATALOGUE',
    CATALOGUE_NO_PRICE = 'CATALOGUE_NO_PRICE',
    CATALOGUE_DATA_SHEET = 'CATALOGUE_DATA_SHEET',
    PRICE = 'PRICE',
    LOGISTIC_DATA = 'LOGISTIC_DATA',
    PHOTO = 'PHOTO',
    PHOTO_THUMBNAIL = 'PHOTO_THUMBNAIL',
    PI_COM = 'PI_COM',
    TI_CER = 'TI_CER',
    SOCIAL = 'SOCIAL',
    TI_CER_IR = 'TI_CER_IR',
    TI_VIEW = 'TI_VIEW',
    PI_MAN = 'PI_MAN',
    TI_PART = 'TI_PART',
    TI_ARTW = 'TI_ARTW',
    /*     TI_CER_SOCIAL = 'TI_CER_SOCIAL',
     */
}

export enum ExportResourceType {
    PI_SAV = 'PI_SAV',
    TI_ARTW = 'TI_ARTW',
    PI_COM = 'PI_COM',
    DATA_SHEET = 'DATA_SHEET',
    ENVIRONMENTAL = 'ENVIRONMENTAL',
    TI_VIEW = 'TI_VIEW',
    TI_CER = 'TI_CER',
    PI_MAN = 'PI_MAN',
    TI_CER_IR = 'TI_CER_IR',
    PI_INF = 'PI_INF',
    TI_INF = 'TI_INF',
    PHOTO = 'PHOTO',
    PHOTO_THUMBNAIL = 'PHOTO_THUMBNAIL',
    REACH = 'REACH',
    SOCIAL = 'SOCIAL',
    TI_PART = 'TI_PART',
    TI_REP = 'TI_REP',
    VIDEO = 'VIDEO',
}
